import { render } from "./BudgetDetails.pug?vue&type=template&id=33e8bc63&lang=pug"
import script from "./BudgetDetails.js?vue&type=script&lang=js"
export * from "./BudgetDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__